import usePrevious from "./usePrevious";

const useHasChanged = (val) => {
  const prevVal = usePrevious(val);
  return prevVal !== val;
};

export default useHasChanged;
